import { PaziaButton } from "components/atoms";
import { EmailPageHeader } from "../components/EmailPageHeader";
import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { useState } from "react";
import { HiPencil, HiTrash } from "react-icons/hi2";
import { emailtemplatesApi } from "api";
import { AdminResourceDeleteModal } from "components/molecules";
import { QUERIES_KEYS } from "queries";
import { useInavalidate } from "utils";
import { useDeleteResourceActions } from "utils/store";
import { useEmailTemplates } from "api/hooks/useEmailTemplates";

export const EmailTemplatesPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { setDeleteResource } = useDeleteResourceActions();
  const [searchPhrase] = useState("");
  const filter = "type eq 0";
  const { emailTemplates, isLoading } = useEmailTemplates(0, 100, searchPhrase, filter);
  const invalidate = useInavalidate(QUERIES_KEYS.EMAIL_TEMPLATES(0, 100, searchPhrase, filter));

  return (
    <div className="">
      <div className="mb-6 flex justify-between">
        <EmailPageHeader>Szablony</EmailPageHeader>
      </div>
      <PaziaButton
        onClick={() => navigate(routes.EMAILS + routes.EMAILS_TRIGGERS_ADD + "?generic=true")}
        className="mb-4"
      >
        Dodaj +
      </PaziaButton>
      <div className="rounded-lg border border-gray-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800">
        {isLoading ? (
          <div className="p-6">
            <p className="text-gray-600 dark:text-slate-400">Ładowanie...</p>
          </div>
        ) : emailTemplates.length === 0 ? (
          <div className="p-6">
            <p className="text-gray-600 dark:text-slate-400">Brak szablonów</p>
          </div>
        ) : (
          <table className="w-full">
            <thead className="border-b border-gray-200 bg-gray-50 dark:border-slate-700 dark:bg-slate-900/40">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-slate-400">
                  Nazwa
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-slate-400">
                  Temat
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-slate-400">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-slate-400">
                  Akcje
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-slate-700">
              {emailTemplates.map((template) => (
                <tr key={template.id} className="hover:bg-gray-50 dark:hover:bg-slate-700/50">
                  <td className="px-6 py-4 text-sm font-medium text-gray-900 dark:text-slate-200">{template.name}</td>
                  <td className="px-6 py-4 text-sm text-gray-600 dark:text-slate-400">{template.subject}</td>
                  <td className="px-6 py-4 text-sm">
                    <span
                      className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${
                        template.isActive
                          ? "bg-green-100 text-green-800 dark:bg-green-900/50 dark:text-green-300"
                          : "bg-gray-100 text-gray-800 dark:bg-slate-700 dark:text-slate-300"
                      }`}
                    >
                      {template.isActive ? "Aktywny" : "Nieaktywny"}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right text-sm">
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={() => navigate(routes.EMAILS + routes.EMAILS_TRIGGERS_EDIT(template.id))}
                        className="rounded p-2 text-blue-600 hover:bg-blue-100 dark:text-blue-400 dark:hover:bg-slate-700"
                        title="Edytuj"
                      >
                        <HiPencil className="h-5 w-5" />
                      </button>
                      <button
                        onClick={() => setDeleteResource(template.id)}
                        className="rounded p-2 text-red-600 hover:bg-red-100 dark:text-red-400 dark:hover:bg-slate-700"
                        title="Usuń"
                      >
                        <HiTrash className="h-5 w-5" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <AdminResourceDeleteModal
        title="Usuń szablon"
        description="Jesteś pewien że chcesz usunąć szablon?"
        onSuccessDelete={() => invalidate()}
        deleteAction={emailtemplatesApi.delete}
      />
    </div>
  );
};
